import HttpService from './httpService';
import config from '../../config';

class RecibosApiService extends HttpService {
  async cargarRecibosPortal({ idAlumno, headquarter }) {
    return this.get('cargarRecibosPortal', { params: { idAlumno, headquarter } });
  }

  async iniciarPagoRecibo({ numRecibo, headquarter, acuerdosAceptados }) {
    return this.post('iniciarPagoReciboPortal', { numRecibo, headquarter, acuerdosAceptados });
  }

  /**
   * «Cambiar tarjeta»: el backend crea la solicitud para el alumno del JWT y
   * devuelve el formulario de 0 € del TPV ({ url, fields, order }).
   */
  async iniciarCambioTarjeta({ idAlumno, headquarter }) {
    return this.post('iniciarCambioTarjetaPortal', { idAlumno, headquarter });
  }

  async descargarReciboPDF({ reciboId, headquarter }) {
    return this.post(
      'exportarReciboPortalPDF',
      { reciboId, headquarter },
      { responseType: 'blob' },
    );
  }
}

const recibosApiService = new RecibosApiService(config.REACT_APP_NODE_API);
export default recibosApiService;
